import * as Sentry from '@sentry/browser';
import {
  Client,
  ClientOptions,
  createClient,
  MessageType,
  PingMessage,
  stringifyMessage,
} from 'graphql-ws';

export interface WSClient extends Client {
  ping(payload?: PingMessage['payload']): void;
}

export const createWSClient = (options: ClientOptions): WSClient => {
  let activeSocket: WebSocket | undefined;
  const client = createClient({
    ...options,
    on: {
      ...options.on,
      opened: (socket: WebSocket) => {
        activeSocket = socket;
        options.on?.opened?.(socket);
      },
      closed: (socket: WebSocket) => {
        activeSocket = undefined;
        options.on?.closed?.(socket);
      },
    },
  });

  return {
    ...client,
    ping: (payload: any) => {
      if (activeSocket && activeSocket?.readyState === WebSocket.OPEN) {
        try {
          activeSocket.send(
            stringifyMessage({
              type: MessageType.Ping,
              payload,
            }),
          );
        } catch (e) {
          if (e instanceof Error) {
            Sentry.captureException(e, {
              contexts: {
                webSocketPing: {
                  error: e,
                },
              },
            });
          }
        }
      }
    },
  };
};
